import { makeStyles } from '@material-ui/core/styles';

import { RiCheckLine, RiCloseLine, RiRobot2Line } from '@remixicon/react';
import classNames from 'classnames';

import { Text } from '@backstage/ui';

import { ResourceNameLink } from '@spotify/confidence-core-react';
import {
  ChatEventNotificationFragment,
  getTypeOrNull,
} from '@spotify/confidence-graphql';

import { ChatInformationBox } from '../ChatInformationBox';

const useStyles = makeStyles({
  title: {
    alignItems: 'center',
    display: 'flex',
    gap: 'var(--bui-space-2)',
  },
  statusIcon: {
    flexShrink: 0,
  },
  success: {
    color: 'var(--bui-fg-success)',
  },
  failure: {
    color: 'var(--bui-fg-danger)',
  },
  label: {
    color: 'var(--bui-fg-secondary)',
  },
  summary: {
    color: 'var(--bui-fg-secondary)',
    marginTop: 'var(--bui-space-1)',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
  },
});

interface NotificationMessageProps {
  notification: ChatEventNotificationFragment;
}

export const NotificationMessage = ({
  notification,
}: NotificationMessageProps) => {
  const classes = useStyles();
  const stopped = notification.childChatStopped;
  if (!stopped) return null;

  const childChat = getTypeOrNull(stopped.childChat);
  const success = stopped.success ?? true;
  const StatusIcon = success ? RiCheckLine : RiCloseLine;

  const childTitle = childChat?.displayName ?? 'Sub-agent';
  const titleText = success ? 'Sub-agent finished' : 'Sub-agent failed';

  return (
    <ChatInformationBox
      icon={<RiRobot2Line size={14} />}
      title={
        <span className={classes.title}>
          <StatusIcon
            size={14}
            className={classNames(
              classes.statusIcon,
              success ? classes.success : classes.failure,
            )}
          />
          <Text variant="body-small" className={classes.label}>
            {titleText}
            {': '}
            {childChat ? (
              <ResourceNameLink name={childChat.name} text={childTitle} />
            ) : (
              childTitle
            )}
          </Text>
        </span>
      }
    >
      {stopped.summary && (
        <Text variant="body-small" className={classes.summary}>
          {stopped.summary}
        </Text>
      )}
    </ChatInformationBox>
  );
};
